import React from 'react';

export default function Step2UserInfo({ formData, setFormData, onNext }) {
  const { Age, Height, Weight, Gender } = formData;

  const isValid = Age && Height && Weight && Gender !== null;

  return (
    <div className="space-y-6">
      <h2 className="text-lg font-bold mb-4">اطلاعات فیزیکی</h2>

      <div >
        <label className="block text-sm mb-1">سن (سال):</label>
        <input
          type="number"
          min="10"
          max="100"
          value={Age}
          onChange={(e) => setFormData({ ...formData, Age: e.target.value })}
className="w-full p-3 rounded-xl border-2 focus:outline-none focus:ring-2 focus:ring-blue-500 dark:border-gray-600 bg-white dark:bg-[#2a2f3b] transition"
        />
      </div>

      <div>
        <label className="block text-sm mb-1">قد (سانتی‌متر):</label>
        <input
          type="number"
          min="100"
          max="250"
          value={Height}
          onChange={(e) => setFormData({ ...formData, Height: e.target.value })}
className="w-full p-3 rounded-xl border-2 focus:outline-none focus:ring-2 focus:ring-blue-500 dark:border-gray-600 bg-white dark:bg-[#2a2f3b] transition"
        />
      </div>

      <div>
        <label className="block text-sm mb-1">وزن (کیلوگرم):</label>
        <input
          type="number"
          min="30"
          max="200"
          value={Weight}
          onChange={(e) => setFormData({ ...formData, Weight: e.target.value })}
className="w-full p-3 rounded-xl border-2 focus:outline-none focus:ring-2 focus:ring-blue-500 dark:border-gray-600 bg-white dark:bg-[#2a2f3b] transition"
        />
      </div>

<div className="flex gap-4">
  <button
    onClick={() => setFormData({ ...formData, Gender: 0 })}
    className={`px-4 py-2 rounded-xl border font-bold transition ${
      formData.Gender === 0
        ? 'bg-blue-600 text-white'
        : 'bg-gray-100 dark:bg-[#2a2f3b] text-gray-700 dark:text-gray-300'
    }`}
  >
    مرد
  </button>
  <button
    onClick={() => setFormData({ ...formData, Gender: 1 })}
    className={`px-4 py-2 rounded-xl border font-bold transition ${
      formData.Gender === 1
        ? 'bg-blue-600 text-white'
        : 'bg-gray-100 dark:bg-[#2a2f3b] text-gray-700 dark:text-gray-300'
    }`}
  >
    زن
  </button>
</div>


      <div className="text-right">
        <button
          onClick={onNext}
          disabled={!isValid}
          className="w-full p-3 bg-blue-600 rounded-xl border-2 hover:bg-blue-700 text-white px-6 py-2 rounded-xl disabled:opacity-50"

        >
          مرحله بعد
        </button>
      </div>
    </div>
  );
}
